var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCameraW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 25 20"
    },
    viewBox: "0 0 25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11.8c-2.4 0-4.4 2-4.4 4.4s2 4.4 4.4 4.4 4.4-2 4.4-4.4-2-4.4-4.4-4.4m0 10.1c-3.1 0-5.7-2.6-5.7-5.7s2.6-5.7 5.7-5.7 5.7 2.6 5.7 5.7-2.6 5.7-5.7 5.7zM4.1 10.3c-.6 0-1.1.5-1.1 1.1v10.5c0 .6.5 1.1 1.1 1.1H23c.6 0 1.1-.5 1.1-1.1V11.4c0-.6-.5-1.1-1.1-1.1h-3.8c-.7 0-1.4-.4-1.7-1.1l-1.1-1.8v-.1c-.3-.1-.5-.3-.8-.3h-4.3c-.3 0-.5.1-.6.4v.1L9.6 9.2c-.3.7-1 1.1-1.7 1.1H4.1zm18.8 14H4.1c-1.3 0-2.4-1.1-2.4-2.4V11.4c0-1.3 1-2.4 2.4-2.4h3.8c.3 0 .5-.1.6-.4v-.1l1.1-1.8c.3-.7 1-1.1 1.7-1.1h4.3c.7 0 1.4.4 1.7 1.1l1.1 1.8v.1c.3.3.5.4.8.4H23c1.3 0 2.4 1.1 2.4 2.4v10.5c-.1 1.3-1.1 2.4-2.5 2.4z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 0.25
    },
    transform: "translate(-1 -5)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraW);
export default __webpack_public_path__ + "static/media/icon_camera_w.629021fb9260625874394b25d0bd7cf7.svg";
export { ForwardRef as ReactComponent };